export const getFeedQuery = /* GraphQL */ `
query GetFeed($limit: Int, $nextToken: String) {
  feed(limit: $limit, nextToken: $nextToken) {
    items {
      id
      userID
      postID
      postOwnerID
      createdAt
      post {
        id
        content
        images
        video
        links
        hashtags
        visibility
        authorID
        authorIdentityId
        likesCount
        commentsCount
        sharesCount
        createdAt
        updatedAt
        author {
          id
          username
          displayName
          avatar
          verified
        }
        likes {
          items {
            id
            postID
            userID
            createdAt
            user {
              id
              username
              displayName
              avatar
            }
          }
        }
        comments(limit: 50) { # <--- ADDED limit: 50 HERE
          items {
            id
            postID
            authorID
            content
            parentID
            createdAt
            updatedAt
            author {
              id
              username
              displayName
              avatar
            }
          }
        }
      }
    }
    nextToken
  }
}

`;

export const listPostsQuery = /* GraphQL */ `
query ListPosts($limit: Int, $nextToken: String) {
  listPosts(limit: $limit, nextToken: $nextToken) {
    items {
      id
      content
      images
      video
      links
      hashtags
      visibility
      authorID
      authorIdentityId
      likesCount
      commentsCount
      sharesCount
      author { id username displayName avatar verified }
      likes { items { id userID } }
      comments { items { id content authorID parentID createdAt author { id username displayName avatar } } }
      createdAt
      updatedAt
    }
    nextToken
  }
}
`;

export const getUserPostsQuery = /* GraphQL */ `
  query GetUserPosts($filter: ModelPostFilterInput, $limit: Int, $nextToken: String) {
    listPosts(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        content
        images
        video
        links
        hashtags
        visibility
        authorID
        authorIdentityId
        likesCount
        commentsCount
        sharesCount
        author { id username displayName avatar verified }
        likes { items { id userID } }
        comments(limit: 50) { items { id content authorID parentID createdAt author { id username displayName avatar } } }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;

export const createPostMutation = /* GraphQL */ `
mutation CreatePost($input: CreatePostInput!) {
  createPost(input: $input) {
    id
    content
    images
    video
    links
    hashtags
    visibility
    authorID
    likesCount
    commentsCount
    sharesCount 
    createdAt
    updatedAt
  }
}
`;

export const updatePostMutation = /* GraphQL */ `
mutation UpdatePost($input: UpdatePostInput!) {
  updatePost(input: $input) {
    id
    content
    images
    video
    links
    hashtags
    visibility
    authorID
    authorIdentityId
    likesCount
    commentsCount
    sharesCount
    createdAt
    updatedAt
    author { id username displayName avatar verified }
    likes { items { id userID } }
    comments(limit: 50) { items { id content authorID parentID createdAt author { id username displayName avatar } } }
  }
}
`;

export const searchPostsQuery = /* GraphQL */ `
  query SearchPosts($filter: ModelPostFilterInput, $limit: Int, $nextToken: String) {
    listPosts(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        content
        images
        video
        links
        hashtags
        visibility
        authorID
        authorIdentityId
        likesCount
        commentsCount
        sharesCount
        createdAt
        updatedAt
        author { id username displayName avatar verified }
        likes { items { id userID } }
        comments(limit: 10) { items { id content authorID parentID createdAt author { id username displayName avatar } } }
      }
      nextToken
    }
  }
`;

export const toggleLikeMutation = /* GraphQL */ `
mutation ToggleLike($postID: ID!) {
  toggleLike(postID: $postID) {
    id
    likesCount
    likes { 
      items { 
        id 
        userID 
      } 
    }
  }
}
`;

export const createCommentMutation = /* GraphQL */ `
mutation AddComment($input: CreateCommentInput!) {
  addComment(input: $input) {
    id
    content
    authorID
    postID
    parentID
    updatedAt
    author { id username displayName avatar }
    createdAt
    post {
      id
      commentsCount
    }
  }
}
`;

export const deletePostMutation = /* GraphQL */ `
mutation DeletePost($id: ID!) {
  deletePost(input: { id: $id }) {
    id
  }
}
`;

export const getTrendingPostsQuery = /* GraphQL */`
  query GetTrendingPosts($limit: Int, $nextToken: String) {
    trendingPosts(limit: $limit, nextToken: $nextToken) {
      items {
        id
        content
        images
        video
        links
        hashtags
        visibility
        authorID
        likesCount
        commentsCount
        sharesCount
        author { id username displayName avatar verified }
        likes { items { id userID } }
        comments { items { id content authorID parentID createdAt author { id username displayName avatar } } }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;

export const getPublicPostsQuery = /* GraphQL */`
  query GetPublicPosts($limit: Int, $nextToken: String) {
    listPosts(limit: $limit, nextToken: $nextToken) {
      items {
        id
        content
        images
        video
        links
        hashtags
        visibility
        authorID
        likesCount
        commentsCount
        sharesCount
        author { id username displayName avatar verified }
        likes { items { id userID } }
        comments { items { id content authorID parentID createdAt author { id username displayName avatar } } }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;